import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "antd";
import { NotificationOutlined, SendOutlined, ClockCircleOutlined, EyeOutlined } from "@ant-design/icons";
import pushBroadcastApi from "../../../api/push-broadcast-api";

// 1 thẻ KPI: icon nền màu nhạt + số to + nhãn.
function StatCard({ icon, label, value, suffix, color }) {
    return (
        <Card bodyStyle={{ padding: 16 }} style={{ borderRadius: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <div style={{ width: 46, height: 46, borderRadius: 12, background: `${color}1a`, color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>
                    {icon}
                </div>
                <div style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 22, fontWeight: 700, lineHeight: 1.1, color: "#1f1f1f" }}>
                        {value}{suffix ? <span style={{ fontSize: 14, fontWeight: 600, color: "#8c8c8c" }}> {suffix}</span> : null}
                    </div>
                    <div style={{ fontSize: 13, color: "#8c8c8c", marginTop: 2 }}>{label}</div>
                </div>
            </div>
        </Card>
    );
}

/**
 * Hàng KPI tổng quan cho trang push (gọi /summary). Tự tải; ẩn lỗi nhẹ nhàng.
 * refreshKey: đổi giá trị để buộc tải lại (vd sau khi xóa/hủy).
 */
function PushStatCards({ refreshKey }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        let alive = true;
        pushBroadcastApi.summary()
            .then(({ data }) => { if (alive) setData(data.data); })
            .catch(() => {});
        return () => { alive = false; };
    }, [refreshKey]);

    const fmt = (n) => (n ?? 0).toLocaleString();
    const cards = [
        { icon: <NotificationOutlined />, label: "Tổng chiến dịch", value: fmt(data?.totalBroadcasts), color: "#1677ff" },
        { icon: <SendOutlined />, label: "Đã gửi (thông báo)", value: fmt(data?.totalDelivered), color: "#52c41a" },
        { icon: <EyeOutlined />, label: "Tỷ lệ mở TB", value: data?.openRate ?? 0, suffix: "%", color: "#722ed1" },
        { icon: <ClockCircleOutlined />, label: "Đang lên lịch", value: fmt(data?.scheduled), color: "#fa8c16" },
    ];

    return (
        <Row gutter={[16, 16]} className="mb-4">
            {cards.map((c) => (
                <Col xs={12} md={6} key={c.label}>
                    <StatCard {...c} />
                </Col>
            ))}
        </Row>
    );
}

export default PushStatCards;
